import React, { useState } from 'react'
import { Button, Select } from 'antd'
import { CloseCircleFilled } from '@ant-design/icons'

import './MaterialSelectWithDropdown.css'

const MaterialSelectWithDropdown = ({
  value,
  defaultValue = null,
  label,
  data,
  search = true,
  className,
  iconClassName,
  errorText,
  itemRender,
  shouldKeepSearchValue,
  searchValue,
  allowClear,
  ...others
}) => {
  const [focus, setFocus] = useState(false)
  const isOccupied = focus || defaultValue || (value && value?.length !== 0)
  const hasIcon = !!iconClassName

  return (
    <div
      className={
        errorText
          ? 'float-label material-dropdown-input-container error'
          : 'float-label material-dropdown-input-container'
      }
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      <div
        className={
          hasIcon ? 'material-textfield with-icon' : 'material-textfield'
        }
        onBlur={() => setFocus(false)}
        onFocus={() => setFocus(true)}
      >
        {!itemRender && (
          <Select
            showSearch={search}
            defaultValue={defaultValue}
            value={value}
            options={data}
            placeholder={null}
            searchValue={searchValue}
            className={'material-select ' + className}
            suffixIcon={<i className="icon-arrow-thin-down arrow-down" />}
            allowClear={
              allowClear
                ? {
                    clearIcon: (
                      <Button
                        type="outline"
                        shape="circle"
                        style={{
                          position: 'absolute',
                          top: '-130%',
                          right: '-10px',
                          color: 'var(--color_grey_g500)!important',
                        }}
                        icon={<CloseCircleFilled />}
                      />
                    ),
                  }
                : allowClear
            }
            {...others}
          />
        )}
        {itemRender && (
          <Select
            showSearch={search}
            defaultValue={defaultValue}
            value={value}
            placeholder={null}
            searchValue={searchValue}
            className={'material-select ' + className}
            suffixIcon={<i className="icon-arrow-thin-down arrow-down" />}
            allowClear={
              allowClear
                ? {
                    clearIcon: (
                      <Button
                        type="outline"
                        shape="circle"
                        style={{
                          position: 'absolute',
                          top: '-130%',
                          right: '-10px',
                          color: 'var(--color_grey_g500)!important',
                        }}
                        icon={<CloseCircleFilled />}
                      />
                    ),
                  }
                : allowClear
            }
            {...others}
          >
            {shouldKeepSearchValue && !!searchValue && (
              <Select.Option key={searchValue} value={searchValue}>
                {searchValue}
              </Select.Option>
            )}
            {data?.map(item => (
              <Select.Option
                key={item?.value + item?.label}
                value={item?.value}
              >
                {itemRender(item)}
              </Select.Option>
            ))}
          </Select>
        )}
        {hasIcon && <span className={'input-icon ' + iconClassName} />}
        <label className={isOccupied ? 'with-value' : ''}>{label}</label>
      </div>
      <div className="error"> {errorText} </div>
    </div>
  )
}

export default MaterialSelectWithDropdown
